import React, { FC, useState } from 'react';
import { Box } from '@mui/material';

type SupplierProfileImageProps = {
    url?: string | null;
    alt: string;
    maxHeight: number;
    /** In px; without it the image is capped at its container's width. */
    maxWidth?: number;
    dataTest: string;
};

/** A profile image scaled to fit, or nothing when it is missing or its link fails to load. */
const SupplierProfileImage: FC<SupplierProfileImageProps> = ({ url, alt, maxHeight, maxWidth, dataTest }) => {
    const [hasFailed, setHasFailed] = useState(false);
    if (!url || hasFailed) return null;
    return (
        <Box
            component="img"
            src={url}
            alt={alt}
            onError={() => setHasFailed(true)}
            sx={{
                display: 'block',
                maxWidth: maxWidth ?? '100%',
                maxHeight,
                objectFit: 'contain',
            }}
            data-test={dataTest}
        />
    );
};

export default SupplierProfileImage;
